<template>
  <div v-if="group" class="pa-5">
    <h4 class="grey-text mb-3">
      <div class="d-flex align-center">
        {{ $t('mapDrawing.groupInfo') }}
        <v-chip :color="handleColors(status)" class="ml-2" x-small>
          {{ $t(`appointment.status.${status}`) }}
        </v-chip>
        <v-chip v-if="isAdminOrPartner && hostName" @click="openModal('GROUP_SET_HOST_MODAL')" class="ml-auto clickable" color="primary" small>
          <v-icon class="white--text" small>
            mdi-account-sync
          </v-icon>
          <strong class="white--text ml-1">
            {{ $t('mapDrawing.changeHost') }}
          </strong>
        </v-chip>
        <v-chip v-if="isAdminOrPartner && hostName" @click="openModal('GROUP_REMOVE_HOST_MODAL')" class="ml-2 clickable" color="error" small>
          <v-icon class="white--text" small>
            mdi-trash-can-outline
          </v-icon>
          <strong class="white--text ml-1">
            {{ $t('mapDrawing.removeHost') }}
          </strong>
        </v-chip>
        <v-chip v-else-if="isAdminOrPartner" @click="openModal('GROUP_SET_HOST_MODAL')" class="ml-auto clickable" color="realEstate" small>
          <v-icon class="white--text" small>
            mdi-plus
          </v-icon>
          <strong class="white--text ml-1">
            {{ $t('mapDrawing.addHost') }}
          </strong>
        </v-chip>
      </div>
    </h4>
    <v-row no-gutters>
      <v-col cols="12" sm="3">
        <h6 class="text-uppercase grey--text">
          {{ $t('mapDrawing.code') }}
        </h6>
        <p class="body-2 mb-3">
          {{ code }}
        </p>
      </v-col>
      <v-col cols="12" sm="3">
        <h6 class="text-uppercase grey--text">
          {{ $t('mapDrawing.date') }}
        </h6>
        <p class="body-2 mb-3">
          {{ catalogDate(date) }}
        </p>
      </v-col>
      <v-col cols="12" sm="6">
        <h6 class="text-uppercase grey--text">
          {{ $t('mapDrawing.scheduledBy') }}
        </h6>
        <p class="body-2 mb-3">
          {{ scheduledBy }}
        </p>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="3">
        <h6 class="text-uppercase grey--text">
          {{ $t('mapDrawing.hostValue') }}
        </h6>
        <p class="body-2 mb-0">
          {{ catalogMonetary(group.hostValue) }}
        </p>
      </v-col>
      <v-col cols="12" sm="3">
        <h6 class="text-uppercase grey--text">
          {{ $t('mapDrawing.totalValue') }}
        </h6>
        <p class="body-2 mb-0">
          {{ catalogMonetary(group.totalValue) }}
        </p>
      </v-col>
      <v-col v-if="hostName" cols="12" sm="6">
        <h6 class="text-uppercase grey--text">
          {{ $t('mapDrawing.host') }}
        </h6>
        <p class="body-2 mb-0">
          {{ hostName }}
        </p>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { handleColors } from '@/util/colors'
import { catalogDate, catalogMonetary } from '@/util/catalog'
import { mapActions } from 'vuex'


export default {
  name: 'SelectedMarkersGroupInfo',

  props: {
    group: {
      type: Object,
      required: false,
    },
  },

  computed: {
    scheduledBy() {
      return this.group.scheduledBy.name
    },

    partner() {
      return this.group.partner.name
    },

    date() {
      return this.group.date
    },

    status() {
      return this.group.status
    },

    total() {
      return this.group.totalAppointments
    },

    code() {
      return this.group.code
    },

    hostName() {
      return this.group?.host?.name
    },

    isAdminOrPartner() {
      const roles = localStorage.getItem('access_roles')
      const userRoles = roles?.split(',')
      return userRoles?.includes('ROLE_ADMIN') || userRoles?.includes('ROLE_PARTNER')
    },
  },

  methods: {
    ...mapActions(['openModal']),
  },

  data() {
    return {
      catalogDate,
      handleColors,
      catalogMonetary,
    }
  }
}
</script>
